const compactFormatter = new Intl.NumberFormat(undefined, {
    notation: 'compact',
    maximumSignificantDigits: 3,
})

/** Compact number formatting (e.g. `877K`, `1.2M`). Framework-agnostic. */
export const formatCompactNumber = (value: number): string =>
    compactFormatter.format(value)
